export enum LocationTypeId {
    HQ = 2,
    Branch = 3,
    Internal = 4,
}
